import React from 'react';
import Header from './Header';
import './AuthPageWrapper.css';

const AuthPageWrapper = ({ children, title, subtitle }) => {
  return (
    <div className="auth-page landing-page modern-dark">
      <Header />
      <section className="auth-page-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-10 col-lg-11">
              {title && (
                <div className="ud-section-title text-center mx-auto mb-5 wow fadeInUp" data-wow-delay=".1s">
                  <h2>{title}</h2>
                  {subtitle && <p>{subtitle}</p>}
                </div>
              )}
              <div className="auth-content-wrapper wow fadeInUp" data-wow-delay=".2s">
                {children}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AuthPageWrapper;
